import type { LinkedInPremiumType } from "@/services/adminApi";

/**
 * Couleur de l'icone Plug en fonction de l'etat du heartbeat.
 *
 * Cohorente avec admin/src/app/plugin-status/page.tsx (l. 78-83) :
 * - emerald < 30s, amber < 120s, red > 120s, gris si jamais connecte.
 */
export function pluginIconColor(
  isConnected?: boolean | null,
  lastSeen?: string | null,
): string {
  if (!isConnected || !lastSeen) return "text-gray-300";
  try {
    const diffSec = (Date.now() - new Date(lastSeen).getTime()) / 1000;
    if (diffSec < 30) return "text-emerald-600";
    if (diffSec < 120) return "text-amber-600";
    return "text-red-600";
  } catch {
    return "text-gray-300";
  }
}

const PREMIUM_LABELS: Record<LinkedInPremiumType, string> = {
  recruiter: "Recruiter Lite",
  sales: "Sales Navigator",
  premium: "Premium",
};

export function premiumLabel(type: LinkedInPremiumType | null | undefined): string {
  if (!type) return "Aucun";
  return PREMIUM_LABELS[type] ?? type;
}

export function formatRelativeFr(iso: string | null | undefined): string {
  if (!iso) return "—";
  try {
    const ms = Date.now() - new Date(iso).getTime();
    if (Number.isNaN(ms)) return iso;
    const s = Math.max(0, Math.round(ms / 1000));
    if (s < 60) return `il y a ${s}s`;
    const m = Math.round(s / 60);
    if (m < 60) return `il y a ${m} min`;
    const h = Math.round(m / 60);
    if (h < 24) return `il y a ${h} h`;
    const d = Math.round(h / 24);
    return `il y a ${d} j`;
  } catch {
    return iso;
  }
}

export function seniorityLabel(oldestYear: number | null | undefined): string {
  if (!oldestYear || oldestYear < 1950 || oldestYear > 2100) return "Inconnue";
  const years = Math.max(0, new Date().getFullYear() - oldestYear);
  if (years === 0) return `depuis ${oldestYear}`;
  if (years === 1) return `depuis ${oldestYear} (~1 an)`;
  return `depuis ${oldestYear} (~${years} ans)`;
}
